import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <path fillOpacity=".3" d="M2 22h20V2z"></path>,
  "SignalCellular0Bar"
);
